import { v4 as uuidV4 } from 'uuid'
import { factories } from '@opallabs/starman'
import { PlanResponse } from '../types'

type ChartDef = PlanResponse['data']['charts']['by_id'][number]

export const createPlaceholderChart = () =>
  factories.asgardBff.components.normalizedChart.build({
    id: `temp-${uuidV4()}`,
  }) satisfies ChartDef

export const insertChart = (newChart: ChartDef, categoryId: string) => {
  return (draftResponse: PlanResponse) => {
    draftResponse.data.charts.by_id[newChart.id] = newChart
    draftResponse.data.categories.by_id[categoryId].chart_id = newChart.id

    return draftResponse
  }
}
